import * as angular from "angular";
import {IController} from "angular";
import {ServiceValidationTemplateModel} from "../../models/service-validation-template.model";

export class AgentValidationsTableComponent implements IController {

  validations: ServiceValidationTemplateModel[];
  onToggleMandatory: Function;
  onEdit: Function;
  onDelete: Function;

  constructor() {
  }

  $onInit() {
  }

}

angular
  .module('bringoz.admin.pricePlan')
  .component('agentValidationsTable', {
    bindings: {
      validations: '<',
      onToggleMandatory: '&',
      onEdit: '&',
      onDelete: '&'
    },
    template: require('./agent-validations-table.html').default,
    controller: AgentValidationsTableComponent
  });
